// The selected business lives outside React so the API client can attach X-Business-Id without
// threading it through every call. Persisted per browser so a reload keeps the selection.
const KEY = 'fm.business';
let current: string | null = (() => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
})();
const listeners = new Set<() => void>();

export const businessContext = {
  get: () => current,
  set: (id: string | null) => {
    current = id;
    try {
      if (id) localStorage.setItem(KEY, id);
      else localStorage.removeItem(KEY);
    } catch {
      // Storage may be unavailable (private mode); selection still works for this tab.
    }
    for (const l of listeners) l();
  },
  subscribe: (l: () => void) => {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
